<template>
  <dashboard-filter
    :is-disabled="isDisabled"
    @change="emitHandler">
    <option
      v-for="organization in organizations"
      :value="organization.id"
      :key="organization.id"
      :selected="organization.id === organizationId"

    >
      {{ organization.name }}
    </option>
  </dashboard-filter>
</template>

<script>
    import DashboardFilter from './DashboardFilter'
    import OrganizationApi from '@/api/Organization.js'
    import FilterMixin     from './mixins/FilterMixin'

    export default {
        mixins: [FilterMixin],

        components: {
            DashboardFilter
        },

        props: {
            organizationId: {
                type: Number
            }
        },

        data: () => ({
            organizations: []
        }),

        async mounted () {
          this.organizations = await this.get()
        },

        methods: {
            get () {
                return new Promise(async (resolve, reject) => {
                    try {
                        let api = new OrganizationApi()

                        const organizations = await api.getAll('true', 'true')

                        resolve(organizations)
                    } catch (error) {
                        reject(error)
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// OrganizationFilter.vue?c6f2d1ce